import { render, staticRenderFns } from "./MyPerformance.vue?vue&type=template&id=890783f8&scoped=true"
import script from "./MyPerformance.vue?vue&type=script&lang=js"
export * from "./MyPerformance.vue?vue&type=script&lang=js"
import style0 from "./MyPerformance.vue?vue&type=style&index=0&id=890783f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890783f8",
  null
  
)

export default component.exports